import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {PhoneCountryInfo} from "../../../models/phone-country-info";
import {OrderService} from "../../services/order.service";
import {PHONE_MASK} from "../../../helpers/format-helpers";
import {NgModel} from "@angular/forms";
import {Product} from "../../../dto/product";
import {environment} from "../../../../environments/environment";

@Component({
  selector: "app-brand-referral",
  templateUrl: "./brand-referral.component.html",
  styleUrls: ["./brand-referral.component.css"]
})
export class BrandReferralComponent implements OnInit {
  displaySuccess = false;
  products: Product[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
  ) {
  }

  private referralCode: string | null;
  vc: string | null;
  countryCodes: any;
  phoneNumber = "";
  isLoading = false;

  isIOS: boolean;
  isAndroid: boolean;

  phoneMask = PHONE_MASK;


  ngOnInit(): void {
    this.referralCode = this.route.snapshot.paramMap.get('brandReferralCode');
    this.vc = this.route.snapshot.queryParams['vc'];

    this.countryCodes = [
      {country: "AT", prefix: 43} as PhoneCountryInfo,
      {country: "DE", prefix: 49} as PhoneCountryInfo,
      {country: "GB", prefix: 44} as PhoneCountryInfo,
    ];


    this.orderService.getProductByBrandReferralCode(this.referralCode).subscribe(products => {
      this.products = products;
    }, err => {});


  }

  checkDevice(): void {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check if iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.isIOS = true;
      this.redirectToAppStore();
    }
    // Check if Android
    else if (/android/i.test(userAgent)) {
      this.isAndroid = true;
      this.redirectToPlayStore();
    }
    // Other devices
    else {

    }
  }

  redirectToAppStore(): void {
    window.location.href = "https://apps.apple.com/de/app/king/id1577565747";
  }

  redirectToPlayStore(): void {
    window.location.href = "https://play.google.com/store/apps/details?id=com.cardcompact.app";
  }

  redirectToGetApp(): void {
    window.location.href = "https://cardbro.cardcompact.com/app";
  }


  submitPhone(): void {

    this.isLoading = true;

    if (!this.phoneNumber) {
      return;
    }
    if (this.phoneNumber.startsWith("00")) {
      this.phoneNumber = this.phoneNumber.substr(2);
    }

    this.orderService.acceptBrandReferral(
      this.referralCode,
      this.phoneNumber,
      this.vc,
    ).subscribe(res => {

      if (res.status == 0) {
        // ok

        if (this.isIOS) {
          this.redirectToAppStore();
        } else if (this.isAndroid) {
          this.redirectToPlayStore();
        } else {
          this.redirectToGetApp();
        }

      } else {
        alert("Fehler: " + res.message);
      }

    });
  }


  protected readonly PHONE_MASK = PHONE_MASK;

  // Access the form control for manual updating
  @ViewChild('phoneNumberForm', { static: true }) phoneNumberForm!: NgModel;
  @ViewChild('phoneInput', { static: true }) phoneInput!: ElementRef;

  // Define the prefix mapping for Austria and Germany
  prefixMapping: { [key: string]: string } = {
    '0650': '43650',
    '0651': '43651',
    '0652': '43652',
    '0660': '43660',
    '0664': '43664',
    '0676': '43676',
    '0677': '43677',
    '0678': '43678',
    '0680': '43680',
    '0681': '43681',
    '0151': '49151',
    '0152': '49152',
    '0155': '49155',
    '0156': '49156',
    '0157': '49157',
    '0160': '49160',
    '0161': '49161',
    '0170': '49170',
    '0171': '49171',
    '0172': '49172',
    '0173': '49173',
    '0174': '49174',
    '0175': '49175',
    '0176': '49176',
    '0177': '49177',
    '0178': '49178',
    '0179': '49179'
  };

  onPhoneNumberChange(value: string) {
    for (let prefix in this.prefixMapping) {
      if (value.startsWith(prefix)) {
        const updatedValue = value.replace(prefix, this.prefixMapping[prefix]);
        this.phoneNumber = updatedValue;
        this.phoneNumberForm.control.patchValue(updatedValue, { emitModelToViewChange: true, emitEvent: false });

        setTimeout(this.moveCursorToEnd.bind(this), 1);
        setTimeout(this.moveCursorToEnd.bind(this), 20);
        setTimeout(this.moveCursorToEnd.bind(this), 30);
        setTimeout(this.moveCursorToEnd.bind(this), 40);
        setTimeout(this.moveCursorToEnd.bind(this), 50);

        break;
      }
    }
  }

  moveCursorToEnd() {
    const input = this.phoneInput.nativeElement;
    const length = input.value.length;
    console.log("input selection len " + length);
    input.focus();
    input.setSelectionRange(length, length);
  }

  protected readonly environment = environment;
}
